import http from '../../shared/http.js';
import { withFlash } from '../../shared/flash.js';
import { bindFormModule } from '../../shared/formBinding.js';
import { bindPasskeyReset } from './userPasskeys.js';
import { formModalSaved, isFormModalOpen } from '../../shared/formModal.js';
import { hideLoading, notifyError, notifySuccess, showLoading } from '../../shared/notify.js';

async function submit(form) {
  const submitButton = form.querySelector('button[type="submit"]');
  const { userId } = form.dataset;
  const data = Object.fromEntries(new FormData(form).entries());

  // The field is always submitted, so an untouched one arrives as ''. Sending
  // it would ask the server to set an empty password; dropping it here is the
  // client half of "leave blank to keep the current one".
  if (!data.password) delete data.password;

  if (submitButton) submitButton.disabled = true;
  showLoading('Wird gespeichert …');

  try {
    if (userId) await http.patch(`/users/${userId}`, data);
    else await http.post('/users', data);

    // In the dialog the list is already behind it, so closing and refetching
    // shows the result without a reload. On the standalone page there is
    // nothing to go back to, so it navigates and the flash key carries the
    // message across the load.
    if (isFormModalOpen()) {
      hideLoading();
      formModalSaved();
      notifySuccess(userId ? 'Benutzer wurde aktualisiert.' : 'Benutzer wurde erstellt.');
    } else {
      window.location.href = withFlash(
        '/users',
        userId ? 'benutzer-aktualisiert' : 'benutzer-erstellt'
      );
    }
  } catch (err) {
    hideLoading();
    if (submitButton) submitButton.disabled = false;
    notifyError(
      err.response?.data?.message || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
    );
  }
}

export function initUserForm() {
  // The reset button rides along in the form's setup, so it is wired in the
  // modal fragment as well as on the standalone page.
  bindFormModule('user-form', submit, bindPasskeyReset);
}
